import { render, staticRenderFns } from "./EditPcsZapNotForRepairs.vue?vue&type=template&id=32981de9&scoped=true&"
import script from "./EditPcsZapNotForRepairs.vue?vue&type=script&lang=js&"
export * from "./EditPcsZapNotForRepairs.vue?vue&type=script&lang=js&"
import style0 from "./EditPcsZapNotForRepairs.vue?vue&type=style&index=0&id=32981de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32981de9",
  null
  
)

export default component.exports